import { AppService } from "../app.service";
import { AuctionScheduleDTO } from "../DTO/auctionScheduleDTO";

export class AuctionSchedule{
    
    public seqNo!:number;
    public auctionStarting?:Date;
    public auctionEnding?:Date;
    public autoRenewTimes?:number;
    public autoRenewDays?:number;
    public noMinimumBid:boolean = false;
    public previousAuctionEnding?:Date;
    public scheduleEnded:boolean = false;
    public wasNeverLive:boolean = false;
    public reserveCredit?:number;
    public timeZoneOffsetMinutes?:number;
    public postponed:boolean = false;
    public showPostponed:boolean = false;

    constructor(){
    }

    get auctionEndingUnix():number|undefined{
        if(!this.auctionEnding) return undefined;
        return this.auctionEnding?.getTime()+AppService.timeDiff;
    }

    get auctionEnded():boolean{
        return this.scheduleEnded; // || (this.auctionEnding?(this.auctionEndingUnix-AppService.correctedDateNowUnix<=0):undefined);
    }

    public static mapToDTO(param:AuctionSchedule) : AuctionScheduleDTO{
        
        let dto = new AuctionScheduleDTO();
        try
        {
            dto.seqNo=param.seqNo;
            if(param.auctionStarting) dto.auctionStarting = param.auctionStarting.toISOString();
            if(param.auctionEnding) dto.auctionEnding = param.auctionEnding.toISOString();
            dto.autoRenewTimes = param.autoRenewTimes;
            dto.autoRenewDays = param.autoRenewDays;
            if(param.noMinimumBid!==undefined) dto.noMinimumBid = param.noMinimumBid;
            if(param.previousAuctionEnding) dto.previousAuctionEnding = param.previousAuctionEnding.toISOString();
            dto.scheduleEnded = param.scheduleEnded;
            dto.wasNeverLive = param.wasNeverLive;
            dto.reserveCredit = param.reserveCredit;
            dto.timeZoneOffsetMinutes = param.timeZoneOffsetMinutes;
            dto.postponed = param.postponed;
            dto.showPostponed = param.showPostponed;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:AuctionScheduleDTO) : AuctionSchedule
    {
        
        let obj = new AuctionSchedule();
        try
        {
            obj.seqNo=param.seqNo;
            if(param.auctionStarting) obj.auctionStarting = new Date(param.auctionStarting);
            if(param.auctionEnding) obj.auctionEnding = new Date(param.auctionEnding);
            obj.autoRenewTimes = param.autoRenewTimes;
            obj.autoRenewDays = param.autoRenewDays;
            if(param.noMinimumBid!==undefined) obj.noMinimumBid = param.noMinimumBid;
            if(param.previousAuctionEnding) obj.previousAuctionEnding = new Date(param.previousAuctionEnding);
            obj.scheduleEnded = param.scheduleEnded;
            obj.wasNeverLive = param.wasNeverLive;
            obj.reserveCredit = param.reserveCredit;
            obj.timeZoneOffsetMinutes = param.timeZoneOffsetMinutes;
            obj.postponed = param.postponed;
            obj.showPostponed = param.showPostponed;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}